export const config = {
  title: "Leith",
  company_logo: "leith.png",
  logo_placements: ["Left Chest", "Yoke"],
  show_image_preview: true,
  embroideries: {
    mens: ["honda"],
    womens: ["honda"],
    hat: [],
    customs: [],
  },
  email_recipients: [
    "lbudbill@gpcorp.com",
    "lbudbell@comcast.net",
    "bsugden@gpcorp.com",
  ],
  stores: [
    {
      name: "Leith Acura",
      address: "2300 Capital Summit Court, Raleigh, NC 27616",
      code: "10118LEIARA",
    },
    {
      name: "Chris Leith Automotive",
      address: "PO Box 1707, Wake Forest, NC 27588",
      code: "CHRIWA",
    },
    {
      name: "Leith Acura",
      address: "2300 Capital Summit Ct, Raleigh, NC 27616",
      code: "LEIARA",
    },
    {
      name: "Leith CDJR",
      address: "11220 N. US HWY 15 501 N, Aberdeen, NC 27603",
      code: "LEICAB",
    },
    {
      name: "Leith Chrysler Jeep",
      address: "400 Autopark Boulevard, Cary, NC 27511",
      code: "LEICCA",
    },
    {
      name: "Leith Corporate Headquarters",
      address: "8005 Capital Blvd, Raleigh, NC 27616",
      code: "LEICRA",
    },
    {
      name: "Leith Ford",
      address: "PO Box 1809, Wendell, NC 27591",
      code: "LEIFWE",
    },
    {
      name: "Leith Honda",
      address: "3940 Capital Hills Drive, NC 27606",
      code: "LEIHRA",
    },
    {
      name: "Leith Lincoln",
      address: "2350 Capital Summit Ct, Raleigh, NC 27616",
      code: "LEILRA",
    },
    {
      name: "Leith Nissan",
      address: "2100 Auto Park Drive, Cary, NC 27511",
      code: "LEINCA",
    },
    {
      name: "Leith Nissan",
      address: "2000 Auto Park Drive, Cary, NC 27511",
      code: "LEITCA",
    },
    {
      name: "Leith BMW/Mercedes Benz",
      address: "5603 Capital Blvd, Raleigh, NC 27616",
      code: "LEITR2",
    },
    {
      name: "Leith Mercedes",
      address: "5601 Capital Boulevard, Raleigh, NC 27616",
      code: "LEITRA",
    },
    {
      name: "Leith Toyota",
      address: "8005 Capital Blvd, Raleigh, NC 27616",
      code: "LEITRL",
    },
    {
      name: "Leith Autopark Kia",
      address: "5330 Rolesville Rd, Wendell, NC 27591",
      code: "LEITWE",
    },
    {
      name: "Leith Volkswagen",
      address: "4005 Capital Hills Drive, Raleigh, NC 27616",
      code: "LEIVRA",
    },
    {
      name: "Leith Chrysler Jeep",
      address: "5500 Capital Blvd, Raleigh, NC 27619",
      code: "LETCRA",
    },
  ],
  bypass_codes: ["LEITH"],
  server_hostname: "https://mxfj3q6m01.execute-api.us-east-1.amazonaws.com",
  account_reps: [
    { name: "Bob Sugden", phone: "678-287-1662" },
    { name: "Louis Budbill", phone: "678-287-1659" },
  ],
  route_prefix: "/leith",
  paypal_not_supported: true,
  password: "LeitH",
};
